import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {ReactLocalStorageService} from '../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import {FieldsJs, ValidarTipoExpiracionDeToken} from '../../../settings/General/General';
import {CONFIG} from "../../../settings/Config/Config";

export const VerificarTokenAccess = {
	Active: (form) => {
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Verificar_Token_Access', {}).then((response) => {
				console.log('RESPONSE');
				let Cfg = {};
				if (FieldsJs.Array(response.data.Cfg)) {
					Cfg = response.data.Cfg
				}
				ReactLocalStorageService.set('Cfg', Cfg);
				let Usr = ReactLocalStorageService.get('Usr');
				Usr.token_expire = response.data.Usr.token_expire;
				if (FieldsJs.Array(response.data.Usr.user_token_time)) {
					Usr.user_token_time = response.data.Usr.user_token_time;
				}
				ReactLocalStorageService.set('Usr', Usr);
				ValidarTipoExpiracionDeToken();
				resolve(response);
			}).catch((error) => {
				if (error.codigo_api === 400) {
					window.location.href =  "/";
				}
				reject(error);
			});
		});
	}
};
